/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { MoveUp } from '@mui/icons-material';
import {
  Box,
  Button,
  Modal,
  Select,
  MenuItem,
  TextField,
} from '@mui/material';
import { useAuth } from '../../auth/useAuth';
import { API_URL } from '../../config/config';
import { StoreData } from '../store/stores.types';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: '10px',
};

interface FormModal {
  name: string;
  userId: string;
  warehouseId: string;
  storeId: string;
  inventoryId: string;
  amount: number;
  productId: string;
}

const InventoryModal: React.FC<{ data: any }> = ({ data }) => {
  const [stores, setStores] = useState<StoreData[]>([]);
  const [open, setOpen] = useState(false);
  const openModal = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { user, token } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState<FormModal>({
    name: data.name,
    userId: user!.id,
    warehouseId: data.warehouse_id,
    storeId: '',
    inventoryId: data.id,
    amount: 0,
    productId: data.product_id,
  });

  useEffect(() => {
    const getStores = async () => {
      try {
        setLoading(true);
        if (!user) return null;
        const res = await fetch(`${API_URL}/store/${user.id}/`);
        if (!res.ok) {
          const text = await res.text();
          throw new Error(text || 'Failed to fetch stores or stores.');
        }
        const inv = await res.json();
        setStores(inv.data);
      } catch (err: any) {
        setError(err.message || 'Unexpected error');
      } finally {
        setLoading(false);
      }
    };

    getStores();
  }, [user]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await fetch(
        `${API_URL}/inventory/${user!.id}/${formData.inventoryId}/transfer`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            name: formData.name,
            productId: formData.productId,
            storeId: formData.storeId,
            warehouseId: formData.warehouseId,
            amount: formData.amount,
          }),
        },
      );

      if (!res.ok) {
        const errText = await res.text();
        throw new Error(errText);
      }

      handleClose();
    } catch (err: any) {
      console.error('Transfer failed:', err);
    }
  };

  return (
    <div>
      <Button
        style={{ marginTop: '30px' }}
        variant="contained"
        color="primary"
        startIcon={<MoveUp />}
        onClick={openModal}
      >
        Transfer
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h1>Transfer Products</h1>
          <h3>Select store</h3>
          <Select
            style={{ width: '100%' }}
            labelId="store-select-label"
            id="store-select"
            value={formData.storeId}
            label="Select Store"
            onChange={e =>
              setFormData({ ...formData, storeId: e.target.value })
            }
          >
            {stores.map(store => (
              <MenuItem key={store.id} value={store.id}>
                {store.name}
              </MenuItem>
            ))}
          </Select>
          <br />
          <br />
          <TextField
            label="Amount"
            type="number"
            fullWidth
            value={formData.amount}
            onChange={e =>
              setFormData({ ...formData, amount: Number(e.target.value) })
            }
            sx={{ mb: 3 }}
          />

          <Button
            onClick={handleSubmit}
            variant="contained"
            fullWidth
            disabled={!formData.storeId || formData.amount <= 0}
          >
            Transfer Inventory
          </Button>
        </Box>
      </Modal>
    </div>
  );
};
export default InventoryModal;
